var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.enableEditClosingDate
      ? _c(
          "div",
          { staticClass: "closing-date-wrapper" },
          [
            _c("closing-date", {
              ref: "closingDate",
              attrs: {
                invalidClosingDate:
                  _vm.partialClosingDate || _vm.invalidClosingDate,
                invalidContactInfo: _vm.invalidContactInfo,
                highlightflags: _vm.highlightflags,
                invalidVisitDayAndTime: _vm.invalidVisitDayAndTime,
              },
              on: {
                "updated:partial": function (val) {
                  return _vm.$emit("update:partialClosingDate", val)
                },
                "update:invalidVisitTimes": function (val) {
                  return (_vm.invalidVisitTimes = val)
                },
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.readonly && !_vm.isWappr && !_vm.isAppr
      ? _c("div", [_c("closing-date-view")], 1)
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }